import axios from 'axios';

export default {
  fetchPrivacyAudit({
    commit,
  }, id) {
    return axios.get(`/privacyAudit/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'privacyAudit',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  savePrivacyAudit(_, privacyAudit) {
    return axios.post('/privacyAudit', privacyAudit);
  },
  deletePrivacyAudit(_, privacyAudit) {
    return axios.delete(`/privacyAudit/${privacyAudit.id}`);
  },
  fetchMeasureList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get(`/privacyAudit/${paginationParams.privacyAuditId}/measureItem`, {
      params: null,
    })
      .then((measureItems) => {
        commit('setMeasureData', measureItems);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  saveMeasure(_, measureItem) {
    return axios.put('/measureItem', measureItem);
  },
  saveTask(_, task) {
    return axios.post(`/measureItem/${task.measure.id}/task`, task);
  },
  setIsRefreshed({ commit }, value) {
    commit('setIsRefreshedField', value);
  },
};
